module.exports = __webpack_public_path__ + "img/甘肃都市调频_01.d878e39e.jpg";